<template>
  <v-layout row wrap>
    <v-flex xs12>
      <v-card>
        

        <v-list>
            <v-list-tile>
              <v-list-tile-content>
                <v-layout row wrap style="width: 100%">
                    <v-flex xs6>
                        <span class="bold-text">Almacén</span>
                    </v-flex>
                    <v-flex xs3>
                        <span class="bold-text">Disponible</span>
                    </v-flex>
                    <v-flex xs3>
                        <span class="bold-text">En ped. compra</span>
                    </v-flex>
                </v-layout>
              </v-list-tile-content>
            </v-list-tile>
            <v-divider></v-divider>

            <template v-for="(avail, index) in availability">
            <v-list-tile
              :key="avail.item+avail.location"
            >
              <v-list-tile-content>
                <v-layout row wrap style="width: 100%">
                    <v-flex xs6>
                        {{avail.location}}
                    </v-flex>
                    <v-flex xs3>
                        {{parseFloat(avail.QtyAvailable).toFixed(2)}}
                    </v-flex>
                    <v-flex xs3>
                        {{parseFloat(avail.PurchLinesQty).toFixed(2)}}
                    </v-flex>
                </v-layout>
              </v-list-tile-content>
            </v-list-tile>
            <v-divider
              :key="index"
            ></v-divider>
          </template>
        </v-list>
      </v-card>
    </v-flex>
  </v-layout>
</template>
<script>
  export default {
    name: 'availabilityList',       
    data: () => ({
      selectedItem: 1,
    }),
    computed:{
        availability:{
            get(){
                return this.$store.state.Available;
            }
        },
        availabilityListVisible: {
            get(){
                return this.$store.state.availabilityListVisible;
            },
            set(value){
                this.$store.state.availabilityListVisible = value;
            }
        }
    }
  }
</script>
<style scoped>
.bold-text{
    font-weight: bold;
}
</style>
